import PropTypes from "prop-types"
import { map } from "lodash"
import SummaryValue from "./summary-value"

/**
 * Component to render multiple summary values in a consistent format.
 * Used to display summary data in KPI section headers.
 */
export default function SummaryValues({ summary, formatter, className = "summary-value" }) {
  return map(summary, (summaryItem, index) => (
    <div className={className} key={index}>
      <SummaryValue summary={summaryItem} formatter={formatter} />
    </div>
  ))
}

SummaryValues.propTypes = {
  summary: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  className: PropTypes.string,
}
